import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { SingleSampleAccessPointUIProps } from '../../../util/types';

import styles from './APWebsitePdp.module.less';

const APWebsitePdp: React.FC<SingleSampleAccessPointUIProps> = ({
  cardTypeLabel,
  handleOpenModal,
}) => {
  return (
    <div className={styles.apPdpPage}>
      <h2 className={styles.apPdpPageTitle}>Try a Free Matching {cardTypeLabel} Sample</h2>
      <p className={styles.apPdpPageText}>
        See and feel our design in person, printed with your names, wedding date, and photo.
      </p>
      <ButtonV2
        variant="secondary"
        role="button"
        onClick={(): void => {
          if (handleOpenModal) {
            handleOpenModal({ entryPoint: 'WEBSITE_PDP' });
          }
        }}
      >
        Order a Free Sample
      </ButtonV2>
    </div>
  );
};

export default APWebsitePdp;
